import { render, staticRenderFns } from "./material-preview-pdf.vue?vue&type=template&id=bd08c8c8&scoped=true"
import script from "./material-preview-pdf.vue?vue&type=script&lang=js"
export * from "./material-preview-pdf.vue?vue&type=script&lang=js"
import style0 from "./material-preview-pdf.vue?vue&type=style&index=0&id=bd08c8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd08c8c8",
  null
  
)

export default component.exports